import { render, staticRenderFns } from "./WaggonInfoHeader.component.vue?vue&type=template&id=27dfae15&"
import script from "./WaggonInfoHeader.component.vue?vue&type=script&lang=js&"
export * from "./WaggonInfoHeader.component.vue?vue&type=script&lang=js&"
import style0 from "./WaggonInfoHeader.component.vue?vue&type=style&index=0&id=27dfae15&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports